export default __webpack_public_path__ + "media/images/mailer-header-741381af88369be83fa48d92b887684b.jpg";